import { Module } from 'vuex-smart-module';
import OrdersInvoicesActions from './actions';
import OrdersInvoicesGetters from './getters';
import OrdersInvoicesMutations from './mutations';
import OrdersInvoicesState from './state';

export default new Module({
  state: OrdersInvoicesState,
  mutations: OrdersInvoicesMutations,
  actions: OrdersInvoicesActions,
  getters: OrdersInvoicesGetters,
});
